import { Box, Text, Inline } from 'braid-design-system';

import { STATUS_CUSTOM } from 'src/constants/roleRequirementStatus';

import VerifiedAssessment from './RoleRequirementCredentialTooltip/VerifiedAssessment';
import type { RegularOrSmall, Verification } from './types';

interface Props {
  answers: Array<{
    id: string;
    text: string;
    isVerified: boolean;
  }>;
  isCardView: boolean;
  showVerifiedTagInAnswers: boolean;
  verifications: Verification[];
  jobApplicationId: string;
  status: string;
  size?: RegularOrSmall;
}

export const Answers = ({
  answers,
  showVerifiedTagInAnswers,
  isCardView,
  verifications,
  jobApplicationId,
  status,
  size,
}: Props) => {
  const answersInTag = showVerifiedTagInAnswers
    ? answers.filter((rrAnswer) => rrAnswer.isVerified)
    : [];
  const answersToDisplay = showVerifiedTagInAnswers
    ? answers.filter((rrAnswer) => !rrAnswer.isVerified)
    : answers;

  return (
    <Inline space="small">
      <Inline space="xsmall" alignY="center" align="left">
        {answersToDisplay.map((answer, index) => (
          <Box
            component="span"
            key={`${jobApplicationId}-${answer.id}-${answer.text}-non-verified-answer`}
            data-cy={`answer-${index}`}
          >
            <Text
              component="span"
              // FIXME: This is to truncate custom answers for the compact job application card. Ideally, this component should just be told how many lines it can display. We can revisit this once we build it locally in the JobApplicationCard.
              maxLines={isCardView && status === STATUS_CUSTOM ? 1 : undefined}
              size={size}
            >
              {index < answersToDisplay.length - 1
                ? `${answer.text},`
                : answer.text}
            </Text>
          </Box>
        ))}
      </Inline>

      <Inline space="xsmall" alignY="center" align="left">
        {answersInTag.map((rrAnswer) => (
          <Box
            component="span"
            key={`${jobApplicationId}-${rrAnswer.id}-${rrAnswer.text}-verified-tag`}
          >
            <VerifiedAssessment
              verifications={verifications}
              jobApplicationId={jobApplicationId}
              answerText={rrAnswer.text}
              isCardView={isCardView}
              size={size}
            />
          </Box>
        ))}
      </Inline>
    </Inline>
  );
};

export default Answers;
